import { render, staticRenderFns } from "./SGoodsCatePointe.vue?vue&type=template&id=3299c746&scoped=true"
import script from "./SGoodsCatePointe.vue?vue&type=script&lang=js"
export * from "./SGoodsCatePointe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299c746",
  null
  
)

export default component.exports